import React, { useState, useEffect } from 'react';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Cargando from '../../../../../Cargando';
import Swal from 'sweetalert2';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { FaEye, FaPencilAlt, FaTrash, FaSearch, FaFilePdf } from 'react-icons/fa';
import CryptoJS from 'crypto-js';
import GenerarPdf from '../../../submoduloscomunes/GeneradorPdf/GenerarPDF';
import AuthUser from '../../../../../pageauth/AuthUser';

export const RW_ReporteCierres = ({ tipoModulo }) => {
    const { ObtenerEstaciones, ObtenerCierresTurnos, ObtenerModulos, ObtenerDetalleCierreTurno, ActualizarCierreTurno } = PuenteApi();
    const { StartCargando, StopCargando } = Cargando();
    const { ReporteListaCierres, ReporteCierreIndividual } = GenerarPdf();
    const { getUser } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [cierres, setCierres] = useState([]);
    const [filtros, setFiltros] = useState({
        estacionId: "",
        moduloId: "", // Esto almacenará "modulo|sector"
        fechaInicio: "",
        fechaFin: ""
    });

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");
        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerCierres(parsed);
        } else {
            obtenerEstaciones();
        }
    }, []);

    useEffect(() => {
        if (filtros.estacionId) {
            obtenerModulosDeEstacion(filtros.estacionId);
        } else {
            setModulos([]);
            setFiltros(prev => ({ ...prev, moduloId: "" }));
        }
    }, [filtros.estacionId]);

    const obtenerEstaciones = async () => {
        StartCargando("Cargando estaciones...");
        const response = await ObtenerEstaciones();
        if (response) {
            setEstaciones(response);
            localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
            await obtenerCierres(response);
        }
        StopCargando();
    };

    const obtenerModulosDeEstacion = async (estacionId) => {
        const estacion = estaciones.find(e => e.id == estacionId);
        if (estacion) {
            StartCargando("Cargando módulos...");
            const response = await ObtenerModulos(estacion.endpoint);
            let modulosObtenidos = [];
            if (response) {
                // ObtenerModulos devuelve response.data.modulos si es exitoso, pero PuenteApi ya devuelve response.data.modulos
                // Revisando PuenteApi, devuelve response.data.modulos directamente.
                modulosObtenidos = response;
            }

            if (tipoModulo) {
                modulosObtenidos = modulosObtenidos.filter(m => m.nombre === tipoModulo);
            }
            setModulos(modulosObtenidos);
            StopCargando();
        }
    };

    const obtenerCierres = async (listaEstaciones, filtrosAplicados = {}) => {
        StartCargando("Cargando reportes...");
        let todosLosCierres = [];

        // Si hay una estación seleccionada, solo buscamos en esa
        if (filtrosAplicados.estacionId) {
            const estacion = listaEstaciones.find(e => e.id == filtrosAplicados.estacionId);
            if (estacion) {
                const params = {
                    fecha_inicio: filtrosAplicados.fechaInicio,
                    fecha_fin: filtrosAplicados.fechaFin,
                    limit: 10
                };

                if (filtrosAplicados.moduloId) {
                    const [modulo, sector] = filtrosAplicados.moduloId.split('|');
                    params.modulo = modulo;
                    params.sector = sector;
                } else if (tipoModulo) {
                    params.modulo = tipoModulo;
                }

                const cierresEstacion = await ObtenerCierresTurnos(estacion.endpoint, params);
                if (cierresEstacion) {
                    // Agregamos info de la estacion para mostrar en tabla
                    const cierresConInfo = cierresEstacion.map(c => ({ ...c, nombreEstacion: estacion.nombre, endpoint: estacion.endpoint }));
                    todosLosCierres = cierresConInfo;
                }
            }
        } else {
            // Si no, buscamos en todas (limitado a 10 por endpoint, luego ordenamos y cortamos)
            for (const estacion of listaEstaciones) {
                const params = {
                    fecha_inicio: filtrosAplicados.fechaInicio,
                    fecha_fin: filtrosAplicados.fechaFin,
                    limit: 10
                };
                if (tipoModulo) {
                    params.modulo = tipoModulo;
                }

                const cierresEstacion = await ObtenerCierresTurnos(estacion.endpoint, params);
                if (cierresEstacion) {
                    const cierresConInfo = cierresEstacion.map(c => ({ ...c, nombreEstacion: estacion.nombre, endpoint: estacion.endpoint }));
                    todosLosCierres = [...todosLosCierres, ...cierresConInfo];
                }
            }
        }

        // Ordenar por fecha descendente
        todosLosCierres.sort((a, b) => new Date(b.fechafin) - new Date(a.fechafin));

        // Si no se filtró por estación, mostrar solo los últimos 10 globales
        if (!filtrosAplicados.estacionId && !filtrosAplicados.fechaInicio) {
            todosLosCierres = todosLosCierres.slice(0, 10);
        }

        setCierres(todosLosCierres);
        StopCargando();
    };

    const handleBuscar = (e) => {
        e.preventDefault();
        if (!filtros.estacionId) {
            Swal.fire('Atención', 'Seleccione una estación', 'warning');
            return;
        }
        obtenerCierres(estaciones, filtros);
    };

    const generarReportePDF = () => {
        if (cierres.length === 0) {
            Swal.fire('Info', 'No hay datos para generar el reporte', 'info');
            return;
        }

        const razonSocial = process.env.REACT_APP_RAZONSOCIAL || "EMPRESA DEMO";
        const domicilio = process.env.REACT_APP_DOMICILIO || "DOMICILIO DEMO";
        const cuit = process.env.REACT_APP_CUIT || "00-00000000-0";
        const empleado = getUser() ? (getUser().name + ' ' + getUser().apellido) : "USUARIO ACTUAL";
        const desde = filtros.fechaInicio ? new Date(filtros.fechaInicio).toLocaleString() : 'Inicio';
        const hasta = filtros.fechaFin ? new Date(filtros.fechaFin).toLocaleString() : 'Fin';
        const deposito = filtros.estacionId ? estaciones.find(e => e.id == filtros.estacionId)?.nombre : 'Todas';

        ReporteListaCierres(cierres, razonSocial, domicilio, cuit, desde, hasta, deposito, empleado);
    };

    const handleGenerarReporte = () => {
        if (cierres.length === 0) {
            Swal.fire('Info', 'No hay datos para generar el reporte', 'info');
            return;
        }

        const razonSocial = process.env.REACT_APP_RAZONSOCIAL || "EMPRESA DEMO";
        const domicilio = process.env.REACT_APP_DOMICILIO || "DOMICILIO DEMO";
        const cuit = process.env.REACT_APP_CUIT || "00-00000000-0";

        // Get module name for "Deposito"
        let deposito = "Todos";
        if (filtros.estacionId) {
            const estacion = estaciones.find(e => e.id == filtros.estacionId);
            if (estacion) deposito = estacion.nombre;
        }
        if (filtros.moduloId) {
            const [modulo, sector] = filtros.moduloId.split('|');
            deposito += ` - ${modulo} ${sector}`;
        } else if (tipoModulo) {
            deposito += ` (${tipoModulo})`;
        }

        // Empleado placeholder or fetch from AuthUser if possible, but for now placeholder is fine or empty
        const empleado = getUser() || "USUARIO ACTUAL";

        ReporteListaCierres(
            cierres,
            razonSocial,
            domicilio,
            cuit,
            filtros.fechaInicio || "Inicio",
            filtros.fechaFin || "Actualidad",
            deposito,
            empleado
        );
    };

    const [showModalEditar, setShowModalEditar] = useState(false);
    const [cierreEditar, setCierreEditar] = useState(null);
    const [formDataEditar, setFormDataEditar] = useState({
        id: "",
        importeTarjetas: "",
        fondoFijo: "",
        aforadoresAuto: [],
        aforadoresManual: [],
        promociones: {
            promociones: { monto: 0 },
            ventaanticipada: { monto: 0 },
            bonificacion: { monto: 0 }
        },
        motivo: ''
    });

    const handleAccion = async (accion, cierre) => {
        if (accion === 'Ver') {
            StartCargando("Generando reporte...");
            try {
                const response = await ObtenerDetalleCierreTurno(cierre.endpoint, cierre.id);
                StopCargando();
                if (response.success) {
                    const data = { ...response.cierre, tiradas_detalle: response.tiradas_detalle, transacciones_detalle: response.transacciones_detalle };
                    const nombreEstacion = cierre.nombreEstacion;
                    const empleado = cierre.empleado;

                    ReporteCierreIndividual(
                        data,
                        process.env.REACT_APP_RAZONSOCIAL,
                        process.env.REACT_APP_DOMICILIO,
                        process.env.REACT_APP_CUIT,
                        empleado,
                        nombreEstacion,
                        data.modulo,
                        data.sector,
                        data.fechafin
                    );
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: response.error });
                }
            } catch (error) {
                StopCargando();
                console.error(error);
                Swal.fire({ icon: 'error', title: 'Error', text: 'Error al obtener detalle del cierre' });
            }
        } else if (accion === 'Modificar') {
            StartCargando("Cargando datos para editar...");
            try {
                const response = await ObtenerDetalleCierreTurno(cierre.endpoint, cierre.id);
                StopCargando();
                if (response.success) {
                    const data = response.cierre;
                    setCierreEditar(data);
                    setFormDataEditar({
                        id: data.id,
                        importeTarjetas: data.importetarjetas,
                        fondoFijo: data.fondofijo,
                        aforadoresAuto: data.aforadoresauto ? JSON.parse(data.aforadoresauto) : [],
                        aforadoresManual: data.aforadoresmanual ? JSON.parse(data.aforadoresmanual) : [],
                        promociones: data.promociones ? JSON.parse(data.promociones) : {
                            promociones: { monto: 0 },
                            ventaanticipada: { monto: 0 },
                            bonificacion: { monto: 0 }
                        },
                        motivo: '' // Reset motive
                    });
                    setShowModalEditar(true);
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: response.error });
                }
            } catch (error) {
                StopCargando();
                console.error(error);
                Swal.fire({ icon: 'error', title: 'Error', text: 'Error al obtener detalle para editar' });
            }
        } else {
            Swal.fire('Info', `Acción: ${accion} sobre cierre ${cierre.num}`, 'info');
        }
    };

    const handleGuardarEdicion = async () => {
        StartCargando("Guardando cambios...");
        try {
            // Get user from local storage
            const userStr = localStorage.getItem('user');
            const user = userStr ? JSON.parse(userStr) : null;

            const dataToSend = {
                ...formDataEditar,
                usuario: user // Send full user object or just what's needed
            };

            const response = await ActualizarCierreTurno(cierreEditar.endpoint, dataToSend);
            StopCargando();
            if (response.success) {
                Swal.fire({ icon: 'success', title: 'Éxito', text: 'Cierre actualizado correctamente' });
                setShowModalEditar(false);
                obtenerCierres(estaciones, filtros); // Refresh list
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: response.error });
            }
        } catch (error) {
            StopCargando();
            console.error(error);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Error al actualizar el cierre' });
        }
    };

    const handleAforadorChange = (index, field, value, type = 'auto') => {
        const key = type === 'auto' ? 'aforadoresAuto' : 'aforadoresManual';
        const newAforadores = [...formDataEditar[key]];
        newAforadores[index][field] = value;
        setFormDataEditar({ ...formDataEditar, [key]: newAforadores });
    };

    const handlePromocionChange = (field, value) => {
        const newPromociones = { ...formDataEditar.promociones };
        if (!newPromociones[field]) newPromociones[field] = {};
        newPromociones[field].monto = value;
        setFormDataEditar({ ...formDataEditar, promociones: newPromociones });
    };

    return (
        <div className="container-fluid">
            <h4 className="mt-3">Reportes de Cierre de Turno</h4>

            {/* Filtros */}
            <div className="card mb-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label>Estación</Form.Label>
                                <Form.Control as="select"
                                    value={filtros.estacionId}
                                    onChange={(e) => setFiltros({ ...filtros, estacionId: e.target.value })}
                                >
                                    <option value="">Todas</option>
                                    {estaciones.map(e => (
                                        <option key={e.id} value={e.id}>{e.nombre}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </div>
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label>Módulo / Sector</Form.Label>
                                <Form.Control as="select"
                                    value={filtros.moduloId}
                                    onChange={(e) => setFiltros({ ...filtros, moduloId: e.target.value })}
                                    disabled={!filtros.estacionId}
                                >
                                    <option value="">Todos</option>
                                    {modulos.map(m => (
                                        <option key={m.id} value={`${m.nombre}|${m.sector}`}>
                                            {m.nombre} - Sector {m.sector} {m.apodo ? `(${m.apodo})` : ''}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </div>
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label>Desde</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    value={filtros.fechaInicio}
                                    onChange={(e) => setFiltros({ ...filtros, fechaInicio: e.target.value })}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-3">
                            <Form.Group>
                                <Form.Label>Hasta</Form.Label>
                                <Form.Control
                                    type="datetime-local"
                                    value={filtros.fechaFin}
                                    onChange={(e) => setFiltros({ ...filtros, fechaFin: e.target.value })}
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12 text-end">
                            <Button type="submit" variant="primary" className="me-2" onClick={handleBuscar} title="Buscar">
                                <FaSearch /> Buscar
                            </Button>
                            <Button variant="secondary" onClick={generarReportePDF} title="Generar Reporte PDF">
                                <FaFilePdf /> Generar Reporte PDF
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Tabla de Resultados */}
            <div className="table-responsive">
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Número</th>
                            <th>Estación</th>
                            <th>Módulo y sector</th>
                            <th>Fecha de Cierre</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cierres.length > 0 ? (
                            cierres.map((cierre, index) => {
                                const modificado = cierre.modificaciones && JSON.parse(cierre.modificaciones).length > 0;
                                return (
                                    <tr key={index} style={modificado ? { backgroundColor: '#fff3cd' } : {}}>
                                        <td>{cierre.num}</td>
                                        <td>{cierre.nombreEstacion}</td>
                                        <td>{cierre.modulo} {cierre.sector}</td>
                                        <td>{new Date(cierre.fechafin).toLocaleString()}</td>
                                        <td>
                                            <Button variant="info" size="sm" className="me-2" onClick={() => handleAccion('Ver', cierre)} title="Ver">
                                                <FaEye />
                                            </Button>
                                            <Button variant="warning" size="sm" className="me-2" onClick={() => handleAccion('Modificar', cierre)} title="Modificar">
                                                <FaPencilAlt />
                                            </Button>
                                            <Button variant="danger" size="sm" onClick={() => handleAccion('Eliminar', cierre)} title="Eliminar">
                                                <FaTrash />
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">No se encontraron cierres.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* Modal Editar */}
            {showModalEditar && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Editar Cierre de Turno</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModalEditar(false)}></button>
                            </div>
                            <div className="modal-body">
                                <Form>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <Form.Group>
                                                <Form.Label>Importe Tarjetas</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={formDataEditar.importeTarjetas}
                                                    onChange={(e) => setFormDataEditar({ ...formDataEditar, importeTarjetas: e.target.value })}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Group>
                                                <Form.Label>Fondo Fijo</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={formDataEditar.fondoFijo}
                                                    onChange={(e) => setFormDataEditar({ ...formDataEditar, fondoFijo: e.target.value })}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <Form.Group>
                                                <Form.Label>Promociones</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={formDataEditar.promociones.promociones?.monto || 0}
                                                    onChange={(e) => handlePromocionChange('promociones', e.target.value)}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-4">
                                            <Form.Group>
                                                <Form.Label>Venta Anticipada</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={formDataEditar.promociones.ventaanticipada?.monto || 0}
                                                    onChange={(e) => handlePromocionChange('ventaanticipada', e.target.value)}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-4">
                                            <Form.Group>
                                                <Form.Label>Bonificación</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={formDataEditar.promociones.bonificacion?.monto || 0}
                                                    onChange={(e) => handlePromocionChange('bonificacion', e.target.value)}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>

                                    <h6 className="mt-4">Aforadores Automáticos</h6>
                                    <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '20px' }}>
                                        <Table size="sm" bordered>
                                            <thead>
                                                <tr>
                                                    <th>Manguera</th>
                                                    <th>Producto</th>
                                                    <th>Inicial</th>
                                                    <th>Final</th>
                                                    <th>Corrida</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formDataEditar.aforadoresAuto.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.manguera}</td>
                                                        <td>{item.tipocombustible}</td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                size="sm"
                                                                value={item.inicial}
                                                                onChange={(e) => handleAforadorChange(index, 'inicial', e.target.value, 'auto')}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                size="sm"
                                                                value={item.final}
                                                                onChange={(e) => handleAforadorChange(index, 'final', e.target.value, 'auto')}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                size="sm"
                                                                value={item.corrida || 0}
                                                                onChange={(e) => handleAforadorChange(index, 'corrida', e.target.value, 'auto')}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>

                                    <h6 className="mt-4">Aforadores Manuales</h6>
                                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        <Table size="sm" bordered>
                                            <thead>
                                                <tr>
                                                    <th>Manguera</th>
                                                    <th>Producto</th>
                                                    <th>Inicial</th>
                                                    <th>Final</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formDataEditar.aforadoresManual.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.manguera}</td>
                                                        <td>{item.tipocombustible}</td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                size="sm"
                                                                value={item.inicial}
                                                                onChange={(e) => handleAforadorChange(index, 'inicial', e.target.value, 'manual')}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                size="sm"
                                                                value={item.final}
                                                                onChange={(e) => handleAforadorChange(index, 'final', e.target.value, 'manual')}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>

                                    <div className="mt-3">
                                        <Form.Group>
                                            <Form.Label>Motivo de la modificación</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                value={formDataEditar.motivo}
                                                onChange={(e) => setFormDataEditar({ ...formDataEditar, motivo: e.target.value })}
                                                placeholder="Ingrese el motivo de la modificación..."
                                            />
                                        </Form.Group>
                                    </div>

                                </Form>
                            </div>
                            <div className="modal-footer">
                                <Button variant="secondary" onClick={() => setShowModalEditar(false)}>Cancelar</Button>
                                <Button variant="primary" onClick={handleGuardarEdicion}>Guardar Cambios</Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
